import { type ReactNode } from 'react';

import OptimizelyIconSVG from '@frontend/assets/Optimizely.svg';

import {
  avatarButton,
  avatarCircle,
  container,
  logo,
  logoAccent,
  logoImage,
  navOrg,
  navProduct,
  navSlash,
  slotWrapper,
  spacer,
  supportMenu,
} from './GlobalHeaderSkeleton.css';

type GlobalHeaderSkeletonProps = {
  children?: ReactNode;
};

export function GlobalHeaderSkeleton({ children }: GlobalHeaderSkeletonProps) {
  return (
    <div className={container} aria-hidden="true">
      <div className={logoAccent} />
      <div className={logo}>
        <img
          src={OptimizelyIconSVG}
          width={30}
          alt=""
          className={logoImage}
          style={{ height: 'auto' }}
        />
      </div>
      <div className={navOrg} />
      <span className={navSlash}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="slash-forward"
          className="svg-inline--fa fa-slash-forward"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          width="20"
          height="16"
        >
          <path
            fill="currentColor"
            d="M312.2 2.281c-7.469-4.484-17.34-2.125-21.94 5.484l-288 480c-4.562 7.578-2.094 17.41 5.5 21.95C10.34 511.3 13.19 512 16 512c5.406 0 10.72-2.766 13.72-7.766l288-480C322.3 16.66 319.8 6.828 312.2 2.281z"
          />
        </svg>
      </span>
      <div className={navProduct} />
      <div className={spacer} />
      <div className={slotWrapper}>{children}</div>
      <span className={supportMenu}>
        <svg
          aria-hidden="true"
          focusable="false"
          viewBox="0 0 512 512"
          width="20"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM240 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S253.3 344 240 344zM285.6 128H226.4C189.8 128 160 157.8 160 194.4V204c0 8.844 7.156 16 16 16S192 212.8 192 204V194.4C192 175.4 207.4 160 226.4 160h59.25C304.6 160 320 175.4 320 194.4c0 12.48-6.781 24-17.06 29.72L242.5 254.3C231.1 260.7 224 272.7 224 285.8V304C224 312.8 231.2 320 240 320S256 312.8 256 304V285.8c0-1.453 .7813-2.797 1.438-3.172l60.41-30.22C338.9 240.7 352 218.5 352 194.4C352 157.8 322.2 128 285.6 128z"
          />
        </svg>
      </span>
      <div className={avatarButton}>
        <div className={avatarCircle} />
      </div>
    </div>
  );
}
